export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error',
};

export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';

export const ACHIEVEMENT_UI_CONFIG = {
  DEFAULT: {
    icon: 'content/images/age-group-icon-04.png',
    defaultDescription: 'Points awarded for completing a PhD.',
    defaultPoints: 500,
  },
  CollegeAdmission: {
    icon: 'content/images/age-group-icon-03.png',
    defaultDescription: 'Points awarded upon acceptance to a college.',
    defaultPoints: 500,
  },
  Graduation: {
    icon: 'content/images/age-group-icon-02.png',
    defaultDescription: 'Points awarded upon successful graduation.',
    defaultPoints: 5000,
  },
  Phd: {
    icon: 'content/images/age-group-icon-04.png',
    defaultDescription: 'Points awarded for completing a PhD.',
    defaultPoints: 500,
  },
  CommunityService: {
    icon: 'content/images/age-group-icon-01.png',
    defaultDescription: 'Acts of service to the community (verified by their community organizations).',
    defaultPoints: 550,
  },
  StartUp: {
    icon: 'content/images/age-group-icon-04.png',
    defaultDescription: 'Startup (verified by their community organizations)',
    defaultPoints: 750,
  },
};

export const AGE_TEXT_QUEST = 'What did you do professionally during your ';
